// extracted by mini-css-extract-plugin
export default {"content":"WalletHome_content__nI2kO","accountHolder":"WalletHome_accountHolder__nZDio"};